import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: undefined,
  };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[AppErrorBoundary] Caught render error', {
      error,
      info,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="screen" style={{ color: '#ff6b6b', gap: '8px' }}>
          <h1>Не удалось отобразить интерфейс</h1>
          <p>Пожалуйста, перезапустите мини-приложение. Если проблема повторяется, отправьте скрин ошибки разработчикам.</p>
          {this.state.error && (
            <code style={{ fontSize: '12px', whiteSpace: 'pre-wrap', background: '#1e2129', padding: '8px', borderRadius: '8px' }}>
              {this.state.error.message}
            </code>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              alignSelf: 'center',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              background: '#51cf66',
              color: '#0f1115',
              fontWeight: 600,
            }}
          >
            Перезагрузить
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

